module.exports = __webpack_public_path__ + "static/media/loading.23faca74.gif";